/** All balance values live here; both the client and authoritative room import them. */
const fighter = (id, name, role, color, hp, speed, damage, range, reload, extra) => ({
  id, name, role, color, hp, speed, damage, range, reload,
  ammo: 3, cooldown: .30, projectileSpeed: 18, pellets: 1, spread: 0,
  radius: .46, chargeDamage: 7000, attack: 'bolt', ...extra
});
export const ROSTER = [
  fighter('santa', 'Santa', 'Heavy hitter', '#ef615b', 7600, 4.25, 420, 6.8, 1.50, {
    pellets: 5, spread: .40, attack: 'snow',
    tagline: 'He sees you when you are camping.',
    attackName: 'Stocking Stuffer', attackText: 'A five-snowball spread. Get close and deliver the whole stocking.',
    super: 'barrage', superName: 'Special Delivery', superText: 'Eight explosive gifts rain onto the aimed area, breaking cover.',
    gadget: 'reload', gadgetName: 'Second Helping', gadgetText: 'Instantly refill all three ammo bars.'
  }),
  fighter('mrs-claus', 'Mrs. Claus', 'Healer', '#ed8fba', 5200, 4.55, 1050, 8.5, 1.25, {
    attack: 'cookie', heal: 850,
    tagline: 'Made with love. And a little violence.',
    attackName: 'Tough Cookie', attackText: 'A flying cookie damages foes or heals the first ally it touches.',
    super: 'hearth', superName: 'Home Sweet Home', superText: 'A warm hearth heals nearby teammates for six seconds.',
    gadget: 'heal', gadgetName: 'Fresh Batch', gadgetText: 'Recover 30% of maximum health immediately.'
  }),
  fighter('present', 'Present', 'Artillery', '#a889ff', 5700, 4.2, 1550, 8.6, 1.85, {
    attack: 'lob', splash: 1.65, projectileSpeed: 13,
    tagline: 'Some assembly. Lots of destruction.',
    attackName: 'Surprise Inside', attackText: 'Lob a gift over walls. It bursts in a generous blast radius.',
    super: 'minefield', superName: 'Do Not Open', superText: 'Scatter six proximity presents that punish anyone approaching.',
    gadget: 'shield', gadgetName: 'Bubble Wrap', gadgetText: 'Take 55% less damage for three seconds.'
  }),
  fighter('candy-cane', 'Killer Candy Cane', 'Assassin', '#ff638a', 4800, 5.15, 1700, 3.2, 1.15, {
    attack: 'melee', spread: .75,
    tagline: 'A little sweet. A lot of sharp.',
    attackName: 'Peppermint Hook', attackText: 'A vicious, wide, close-range candy slash.',
    super: 'hook', superName: 'Sugar Rush', superText: 'Dash through enemies, dealing damage and knocking them aside.',
    gadget: 'haste', gadgetName: 'Mint Condition', gadgetText: 'Move 40% faster for four seconds.'
  }),
  fighter('gingerbread', 'Gingerbread Guy', 'Skirmisher', '#e7aa62', 5100, 4.95, 470, 7.5, 1.20, {
    attack: 'crumb', pellets: 3, spread: .13,
    tagline: 'Catch him. He dares you.',
    attackName: 'Crumb Punch', attackText: 'A tight trio of hot cookie crumbs with reliable mid-range damage.',
    super: 'overdrive', superName: 'Can\'t Catch Me', superText: 'Five seconds of faster movement, attacks and reloading.',
    gadget: 'heal', gadgetName: 'Icing On Top', gadgetText: 'Patch yourself up for 30% of maximum health.'
  }),
  fighter('light-bulb', 'Holiday Light Bulb', 'Controller', '#f16ffc', 4400, 4.65, 1150, 8.2, 1.55, {
    attack: 'electric', chain: 2,
    tagline: 'The brightest idea is to run.',
    attackName: 'Live Wire', attackText: 'An electric bolt arcs to two nearby enemies for reduced damage.',
    super: 'storm', superName: 'Power Surge', superText: 'A crackling electric field damages and slows its occupants.',
    gadget: 'reload', gadgetName: 'Recharge', gadgetText: 'Refill all ammo immediately.'
  }),
  fighter('yeti', 'Yeti', 'Tank', '#79e4ff', 9200, 3.95, 1950, 3.5, 1.70, {
    attack: 'melee', spread: .92, radius: .59,
    tagline: 'Big feelings. Bigger fists.',
    attackName: 'Cold Shoulder', attackText: 'A massive icy swipe that punishes clustered opponents.',
    super: 'leap', superName: 'Avalanche', superText: 'Leap over cover, then slam down with a stunning, wall-breaking blast.',
    gadget: 'shield', gadgetName: 'Thick Skin', gadgetText: 'Take 55% less damage for three seconds.'
  }),
  fighter('polar-bear', 'Polar Bear', 'Bruiser', '#b6d9ff', 8100, 4.20, 570, 5.4, 1.5, {
    attack: 'snow', pellets: 4, spread: .42, radius: .54,
    tagline: 'A bear hug you will not forget.',
    attackName: 'Frostbite', attackText: 'A short-range blast of four icy chunks.',
    super: 'blizzard', superName: 'Polar Vortex', superText: 'Summon a huge slowing blizzard. You gain a short protective shield.',
    gadget: 'heal', gadgetName: 'Hibernation Snack', gadgetText: 'Recover 30% of maximum health.'
  }),
  fighter('yule-log', 'Yule Log', 'Controller', '#ff965c', 6500, 4.1, 380, 5.9, 1.5, {
    attack: 'ember', pellets: 4, spread: .32, burn: 170,
    tagline: 'Seasoned. Smoldering. Slightly unhinged.',
    attackName: 'Spitfire', attackText: 'Glowing embers leave enemies burning for three seconds.',
    super: 'firetrail', superName: 'On a Roll', superText: 'Charge forward and leave a damaging trail of fire behind.',
    gadget: 'shield', gadgetName: 'Hardwood', gadgetText: 'Take 55% less damage for three seconds.'
  }),
  fighter('evil-elf', 'Evil Elf', 'Assassin', '#79e5a0', 4300, 5.2, 760, 7.8, 1.15, {
    attack: 'dagger', pellets: 2, spread: .09, burn: 105,
    tagline: 'Employee of the month. On the naughty list.',
    attackName: 'Sharp Practice', attackText: 'Twin venom-tipped daggers keep damage ticking after the hit.',
    super: 'blink', superName: 'Silent Night', superText: 'Blink toward your aim and disappear for three seconds. Attacking reveals you.',
    gadget: 'haste', gadgetName: 'Small Print', gadgetText: 'Move 40% faster for four seconds.'
  }),
  fighter('narwhal', 'Narwhal', 'Sharpshooter', '#82b8ff', 4800, 4.4, 1850, 11.8, 1.9, {
    attack: 'ice', pierce: 2, projectileSpeed: 27,
    tagline: 'One point. Very well made.',
    attackName: 'Tusk, Tusk', attackText: 'A long-range ice lance pierces two enemies.',
    super: 'wave', superName: 'Tidal Trouble', superText: 'A broad, piercing wave sweeps enemies back and shatters cover.',
    gadget: 'reload', gadgetName: 'Deep Breath', gadgetText: 'Instantly refill all ammo.'
  }),
  fighter('cowboy', 'Ostrich-Riding Cowboy', 'Ranger', '#ffc47d', 5400, 5.05, 1200, 9.4, 1.4, {
    attack: 'star', projectileSpeed: 23,
    tagline: 'All hat. Absolutely no brakes.',
    attackName: 'High Noon', attackText: 'A quick, accurate star shot with excellent reach.',
    super: 'stampede', superName: 'Birds of a Feather', superText: 'Three feisty ostriches chase and peck nearby opponents.',
    gadget: 'haste', gadgetName: 'Giddy Up', gadgetText: 'Move 40% faster for four seconds.'
  }),
  fighter('blitzen', 'Blitzen', 'Vanguard', '#e8bd7e', 6800, 4.85, 1450, 4, 1.4, {
    attack: 'melee', spread: .65,
    tagline: 'Reindeer games just got personal.',
    attackName: 'Antler Up', attackText: 'Sweep a wide arc with a formidable set of antlers.',
    super: 'charge', superName: 'Reindeer Rush', superText: 'A long, cover-breaking charge sends enemies flying.',
    gadget: 'shield', gadgetName: 'Jingle Armor', gadgetText: 'Take 55% less damage for three seconds.'
  }),
  fighter('nutcracker', 'Nutcracker', 'Sharpshooter', '#ef7b8b', 4600, 4.15, 2050, 12.3, 2, {
    attack: 'musket', projectileSpeed: 31,
    tagline: 'Discipline. Precision. A cracking good shot.',
    attackName: 'Toy Soldier', attackText: 'A high-powered musket round. Make every shot count.',
    super: 'turret', superName: 'Royal Guard', superText: 'Deploy a destructible sentry that automatically fires at visible enemies.',
    gadget: 'reload', gadgetName: 'Quick March', gadgetText: 'Instantly refill all ammo.'
  }),
  fighter('snowman', 'Snowman', 'Controller', '#a9ecf2', 6100, 4.4, 1300, 8.6, 1.6, {
    attack: 'snow', splash: 1.15, slow: .4,
    tagline: 'Chill is not in his vocabulary.',
    attackName: 'Snow Problem', attackText: 'A bursting snowball slows enemies caught in the splash.',
    super: 'freeze', superName: 'Absolute Zero', superText: 'An icy shockwave damages and briefly freezes nearby enemies.',
    gadget: 'heal', gadgetName: 'Fresh Powder', gadgetText: 'Rebuild 30% of maximum health.'
  }),
  fighter('evergreen', 'Evergreen Tree', 'Support', '#6ae3b0', 7500, 3.9, 500, 7.3, 1.55, {
    attack: 'ornament', pellets: 3, spread: .25, radius: .54,
    tagline: 'Rooted in the holiday spirit.',
    attackName: 'Deck the Brawls', attackText: 'Three sharp, gleaming ornaments fan out toward enemies.',
    super: 'roots', superName: 'Season\'s Entanglings', superText: 'A glowing grove roots foes once, then damages foes and heals allies.',
    gadget: 'shield', gadgetName: 'Everguard', gadgetText: 'Take 55% less damage for three seconds.'
  })
];
export const BY_ID = Object.fromEntries(ROSTER.map(c => [c.id, Object.freeze(c)]));
export const MODES = {
  gift: { id: 'gift', name: 'Gift Grab', label: '3 vs 3', description: 'Collect 10 gifts. Hold the lead for 15 seconds.', players: 6, duration: 180, map: 'Frostfall Festival' },
  showdown: { id: 'showdown', name: 'Snowdown', label: 'Free for all', description: 'Collect power cubes. Survive the closing blizzard.', players: 6, duration: 180, map: 'The Last Snowglobe' },
  duel: { id: 'duel', name: 'Duel', label: '1 vs 1', description: 'First to 5 takedowns. No place on the nice list.', players: 2, duration: 120, map: 'Candy Cane Crossing' }
};
export const TICK_RATE = 30;
export const DT = 1 / TICK_RATE;
export const MAX_PLAYERS = 6;
